import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";

export const NameDialog = ({ open, onOpenChange, title, placeholder, onSubmit, testid }) => {
  const [name, setName] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    await onSubmit(name.trim());
    setName("");
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent aria-describedby={undefined} className="rounded-none sm:max-w-md" data-testid={`${testid}-dialog`}>
        <form onSubmit={submit}>
          <DialogHeader><DialogTitle className="font-display">{title}</DialogTitle></DialogHeader>
          <Input autoFocus value={name} onChange={(e) => setName(e.target.value)} placeholder={placeholder}
            className="my-4 rounded-none" data-testid={`${testid}-name-input`} />
          <DialogFooter>
            <Button type="submit" className="rounded-none bg-brand hover:bg-brand/90 text-onbrand" data-testid={`${testid}-submit-button`}>Save</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
